import { post, get } from '@integec/fetch-task'

export const getPeakDefinition = targetInfo =>
  get(targetInfo, 'common/peak-definition')

export const postPeakDefinition = targetInfo => data =>
  post(targetInfo, 'common/peak-definition')(data)

export const deletePeakDefinition = targetInfo => data =>
  post(targetInfo, 'common/peak-definition/delete')(data)
